import { AnyAction } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';

export const ueberschwemmungSelbstbeteiligungReducer = function (
  sectionState: number = null,
  action: AnyAction,
  appState: IAppState,
): number {
  if (action.type === GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED) {
    const actionPayload = action.payload;
    if (actionPayload.forApp === App.VWG && appState.angebotsId === actionPayload.angebotsId) {
      let newSectionState = cloneDeep(sectionState);
      const extremwetterschutzSelbstbeteiligung = actionPayload.selbstbehaltUeberschwemmung;
      if (extremwetterschutzSelbstbeteiligung) {
        newSectionState = extremwetterschutzSelbstbeteiligung;
      }

      return newSectionState;
    }
  }
  return sectionState;
};
